module.exports = __webpack_public_path__ + "media/images/scoreBet__scoreDown-59ae5c69de860f6ee532448e7a8b8648.png";